import { render, staticRenderFns } from "./MatchRoundSelectorItem.vue?vue&type=template&id=383a6856&scoped=true&"
import script from "./MatchRoundSelectorItem.vue?vue&type=script&lang=js&"
export * from "./MatchRoundSelectorItem.vue?vue&type=script&lang=js&"
import style0 from "./MatchRoundSelectorItem.vue?vue&type=style&index=0&id=383a6856&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383a6856",
  null
  
)

export default component.exports